module.exports = __webpack_public_path__ + "img/1790396613784_screenshot.2b72c5c9.png";